import moment from 'moment';

import {
    getCreateDateTime
} from '../../utils/DateUtils';

export const biMasterModel = () => {
    return {
        docId: null,
        compId: null,
        docNo: null,
        docDate: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
        docDueDate: moment().utcOffset(7, true).format('YYYY-MM-DD HH:mm:ss.SSS'),
        docStatus: 1,
        docPaidStatus: null,
        arID: null,
        arCode: null,
        arName: null,
        createdDate: getCreateDateTime(),
        createdByName: window.localStorage.getItem('name'),
        createdById: window.localStorage.getItem('emp_id'),
        updateDate: null,
        updateByName: null,
        updateById: null,
        cancelDate: null,
        cancelByName: null,
        cancelById: null,
        blTotal: 0,
        blDis: 0,
        blIsVat: null,
        blVat: 0,
        blNetTotal: 0,
        docIsInv: null,
        docInvNo: null,
        docIsInvFrom: null,
        discountValue: 0,
        discountValueType: null,
        docPaidPic: null,
        docStatusPaidType: null,
        docRemark1: null,
        docRemark2: null,
        docBlReceiveDate: null,
        payTotal: null
    };
};